import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef, useId } from 'react';
import { DropdownGroupContextProvider } from '../../contexts/group-context.mjs';
import { DropdownMenuRadioGroup } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownGroup } from '../../shared/styles/group.vanilla.mjs';

const DropdownRadioGroup = forwardRef(({ className: classNameFromProps, title, ...props }, forwardedRef) => {
  const radioGroupId = useId();
  const className = classNames(dropdownGroup, classNameFromProps);
  return /* @__PURE__ */ jsxs(DropdownGroupContextProvider, { id: radioGroupId, children: [
    title,
    /* @__PURE__ */ jsx(
      DropdownMenuRadioGroup,
      {
        "aria-labelledby": radioGroupId,
        className,
        ref: forwardedRef,
        ...props
      }
    )
  ] });
});

export { DropdownRadioGroup };
//# sourceMappingURL=RadioGroup.mjs.map
